import { createSelector } from 'reselect';

export const getMobileScreenSize = createSelector(
  state => state.ui?.screenSize?.isMobile,
  isMobile => isMobile
);

export const getTabletSize = createSelector(
  state => state.ui?.screenSize?.isTablet,
  isTablet => isTablet
);
